//	NOTE: HEADER TEXT FORMATTING:
//					STARTS WITH A '!' MEANS CONTAGIOUS AND IT IS EMPHASIZED(BOLD AND ITALICS)
//					STARTS WITH A '#' MEANS JUST ITALICS
//					STARTS WITH A '&' MEANS italics for a species genus but the word 'other' is present (no italics for it)

import {CommaSafeCSVString, CommaSeperateNumber, NSGToString, TestValueToString} from "./table_formatters";
import {CELL_SIZES, DATE_FORMATS, HEADER_TEXT_CODES, TEST_TYPES} from "../../../utils/constants";
import {DisplayDate} from "../../../utils/helpers";

export const SOLO_META_TABLE = [
	{
		name: 'binary_cow_id',
		headerText: 'Cow ID',
		filtered: true,
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'individual_sample_type',
		headerText: 'Type',
		filtered: true,
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	},
	{
		name: 'sample_date',
		headerText: 'Sample Date',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			DisplayDate(value, DATE_FORMATS.table)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'binary_nsg',
		headerText: 'NSG',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			value === TEST_TYPES.lost_in_transit ? value : NSGToString(value)
		),
		csvFormat: value => (
			value === TEST_TYPES.lost_in_transit ? value : NSGToString(value)
		),
		dairyCompCode: 'N'
	},
	{
		name: 'staph_aureus',
		headerText: `${HEADER_TEXT_CODES.EMPHASIZE}S.aureus`,
		displayText: "Staph. aureus",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'R'
	},
	{
		name: 'strep_ag',
		headerText: '!Strep.ag.',
		displayText: "Strep. ag",
		cellSize: CELL_SIZES.small,
		contagious: true,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'A'
	},
	{
		name: 'staph_other',
		headerText: '&Staph. other',
		displayText: "Staph Other",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'C'
	},
	{
		name: 'strep_other',
		headerText: '&Strep. other',
		displayText: "Strep Other",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'S'
	},
	{
		name: 'coliform',
		headerText: 'Coliform',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'other',
		headerText: 'Other',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'O'
	},
	{
		name: 'binary_day4',
		headerText: 'Myco Day 4',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.myco, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'binary_day7',
		headerText: 'Myco Day 7',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.myco, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'sample_comments',
		headerText: 'Comments',
		cellSize: CELL_SIZES.large,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	}
]

export const BULK_META_TABLE = [
	{
		name: 'bulk_tank',
		headerText: 'Tank',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		filtered: true,
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	},
	{
		name: 'sample_date',
		headerText: 'Sample Date',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			DisplayDate(value, DATE_FORMATS.table)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'bulk_staph_aureus',
		headerText: '!S.aureus',
		displayText: "Staph. aureus",
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		contagious: true,
		format: value => (
			value === TEST_TYPES.lost_in_transit ? value : CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(value === TEST_TYPES.lost_in_transit ? value : CommaSeperateNumber(value))
		),
		dairyCompCode: 'R'
	},
	{
		name: 'bulk_strep_ag',
		headerText: '!Strep.ag.',
		displayText: "Strep. ag",
		cellSize: CELL_SIZES.medium,
		contagious: true,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		),
		dairyCompCode: 'A'
	},
	{
		name: 'bulk_staph_other',
		headerText: '&Staph. other',
		displayText: "Staph. other",
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		),
		dairyCompCode: 'C'
	},
	{
		name: 'bulk_strep_other',
		headerText: '&Strep. other',
		displayText: "Strep. other",
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		),
		dairyCompCode: 'S'
	},
	{
		name: 'bulk_plate_coliform',
		headerText: 'Coliform',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'bulk_miscellaneous',
		headerText: 'Misc.',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.culturettes],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'bulk_spc',
		headerText: 'Total SPC',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full,TEST_TYPES.standard_plate, TEST_TYPES.water, TEST_TYPES.bedding],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'bulk_lpc',
		headerText: 'LPC',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.lab_pasteurization],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'bulk_pi',
		headerText: 'PI',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.preliminary_incubation],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'bulk_macconkey_coliform',
		headerText: 'Coliform Count',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.coliform],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'salmonella',
		headerText: 'Salmonella',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.salmonella],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'bulk_myco_day4',
		headerText: '4 Days',
		displayText: "Myco Day 4",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.myco_broth],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'bulk_myco_day7',
		headerText: '7 Days',
		displayText: "Myco Day 7",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.myco_broth],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'bulk_myco_broth',
		headerText: '7 Day Broth',
		displayText: "Myco Day 7 Broth",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.full, TEST_TYPES.myco_broth],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'sample_comments',
		headerText: 'Comments',
		cellSize: CELL_SIZES.large,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	}
]

export const HERD_META_TABLE = [
	{
		name: 'herd_tube_number',
		headerText: 'Tube No.',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'herd_pen',
		headerText: 'Pen',
		filtered: true,
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'binary_cow_id',
		headerText: 'Cow ID',
		cellSize: CELL_SIZES.medium,
		filtered: true,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'sample_date',
		headerText: 'Sample Date',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			DisplayDate(value, DATE_FORMATS.table)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'binary_nsg',
		headerText: 'NSG',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			value === TEST_TYPES.lost_in_transit ? value : NSGToString(value)
		),
		csvFormat: value => (
			value === TEST_TYPES.lost_in_transit ? value : NSGToString(value)
		),
		dairyCompCode: 'N'
	},
	{
		name: 'staph_aureus',
		headerText: `${HEADER_TEXT_CODES.EMPHASIZE}S.aureus`,
		displayText: "Staph. aureus",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'R'
	},
	{
		name: 'strep_ag',
		headerText: '!Strep.ag.',
		displayText: "Strep. ag",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'A'
	},
	{
		name: 'staph_other',
		headerText: '&Staph. other',
		displayText: "Staph. other",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'C'
	},
	{
		name: 'strep_other',
		headerText: '&Strep. other',
		displayText: "Strep. other",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'S'
	},
	{
		name: 'coliform',
		headerText: 'Coliform',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'other',
		headerText: 'Other',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.blood_agar_plate, TEST_TYPES.both],
		format: value => (
			TestValueToString(value)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'O'
	},
	{
		name: 'binary_day4',
		headerText: 'Myco Day 4',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.myco, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'binary_day7',
		headerText: 'Myco Day 7',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.myco, TEST_TYPES.both],
		contagious: true,
		format: value => (
			TestValueToString(value, true)
		),
		csvFormat: value => (
			value
		),
		dairyCompCode: 'M'
	},
	{
		name: 'sample_comments',
		headerText: 'Comments',
		cellSize: CELL_SIZES.large,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	}
]

export const COMP_META_TABLE = [
	{
		name: 'sample_date',
		headerText: 'Sample Date',
		cellSize: CELL_SIZES.medium,
		partOfTests: [],
		format: value => (
			DisplayDate(value, DATE_FORMATS.table)
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_tank_pen',
		headerText: 'Tank/Pen',
		cellSize: CELL_SIZES.medium,
		partOfTests: [TEST_TYPES.component],
		filtered: true,
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_fat',
		headerText: 'Fat',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_true_protein',
		headerText: 'True Protein',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_total_protein',
		headerText: 'Total Protein',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_lactose',
		headerText: 'Lactose',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_solids_non_fat',
		headerText: 'SNF',
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			value
		),
		csvFormat: value => (
			value
		)
	},
	{
		name: 'component_somatic_cell_count',
		headerText: "SCC",
		cellSize: CELL_SIZES.small,
		partOfTests: [TEST_TYPES.component],
		format: value => (
			CommaSeperateNumber(value)
		),
		csvFormat: value => (
			CommaSafeCSVString(CommaSeperateNumber(value))
		)
	},
	{
		name: 'sample_comments',
		headerText: 'Comments',
		cellSize: CELL_SIZES.large,
		partOfTests: [],
		format: value => (
			value
		),
		csvFormat: value => (
			CommaSafeCSVString(value)
		)
	}
]